<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('mobileLogsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="mobile-log-detail-workspace"
         [class.mobile-log-detail-workspace--loading]="isLoading">
      <mat-card class="mobile-log-panel mobile-log-panel--detail">
        <div class="mobile-log-panel__header">
          <div class="mobile-log-panel__heading">
            <span class="mobile-log-panel__eyebrow">{{ 'mobileLogsCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="mobile-log-panel__actions">
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
          </div>
        </div>

        <div class="mobile-log-panel__body">
          @if (selectedMobileLog; as log) {
          <div class="mobile-log-detail">
            <div class="card mobile-log-detail__summary mb-0">
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6 col-xl-3">
                    <div class="mobile-log-metric-card">
                      <span>{{ 'mobileLogsCatalog.fields.employeeNumber' | translate }}</span>
                      <strong>{{ log.employeeNumber || '-' }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="mobile-log-metric-card">
                      <span>{{ 'mobileLogsCatalog.fields.status' | translate }}</span>
                      <strong>{{ log.statusLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="mobile-log-metric-card">
                      <span>{{ 'mobileLogsCatalog.fields.source' | translate }}</span>
                      <strong>{{ log.sourceLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="mobile-log-metric-card">
                      <span>{{ 'mobileLogsCatalog.fields.deviceCreatedAt' | translate }}</span>
                      <strong>{{ log.deviceCreatedAtLabel }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mobile-log-detail__section-card mb-0">
              <div class="card-body">
                <div class="mobile-log-section-heading">
                  <h4>{{ 'mobileLogsCatalog.sections.general' | translate }}</h4>
                  <p>{{ 'mobileLogsCatalog.sections.generalDescription' | translate }}</p>
                </div>
                <div class="row g-3">
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.employee' | translate }}</span><strong>{{ log.employeeLabel || '-' }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.company' | translate }}</span><strong>{{ log.companyName || '-' }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.orgUnit' | translate }}</span><strong>{{ log.orgUnitName || '-' }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.actionType' | translate }}</span><strong>{{ log.actionType || '-' }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.entityType' | translate }}</span><strong>{{ log.entityTypeLabel }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.eventType' | translate }}</span><strong>{{ log.eventTypeLabel }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.reasonCode' | translate }}</span><strong>{{ log.reasonCodeLabel }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.createdAt' | translate }}</span><strong>{{ log.createdAtLabel }}</strong></div></div>
                  <div class="col-md-6 col-xl-4"><div class="mobile-log-soft-card"><span>{{ 'mobileLogsCatalog.fields.updatedAt' | translate }}</span><strong>{{ log.updatedAtLabel }}</strong></div></div>
                  <div class="col-12"><div class="mobile-log-soft-card mobile-log-soft-card--full"><span>{{ 'mobileLogsCatalog.fields.description' | translate }}</span><strong>{{ log.description || '-' }}</strong></div></div>
                </div>
              </div>
            </div>

            @if (hasLocation) {
            <div class="card mobile-log-detail__section-card mb-0">
              <div class="card-body">
                <div class="mobile-log-section-heading">
                  <h4>{{ 'mobileLogsCatalog.sections.location' | translate }}</h4>
                  <p>{{ 'mobileLogsCatalog.sections.locationDescription' | translate }}</p>
                </div>
                <div class="row g-3 align-items-stretch">
                  <div class="col-xl-4">
                    <div class="mobile-log-soft-card mobile-log-soft-card--full h-100">
                      <span>{{ 'mobileLogsCatalog.fields.coordinates' | translate }}</span>
                      <strong>{{ log.coordinatesLabel }}</strong>
                      <span>{{ 'mobileLogsCatalog.fields.accuracy' | translate }}</span>
                      <strong>{{ log.accuracyLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-xl-8">
                    <div class="mobile-log-map-shell">
                      <div #mobileLogMap class="mobile-log-map"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }

            @if (hasMetadata) {
            <div class="card mobile-log-detail__section-card mb-0">
              <div class="card-body">
                @if (metadataInsight; as insight) {
                <div class="metadata-insight" [attr.data-tone]="insight.tone">
                  <div class="metadata-insight__header">
                    <div class="metadata-insight__main">
                      <span class="metadata-insight__icon">
                        <mat-icon>{{ insight.icon }}</mat-icon>
                      </span>
                      <div>
                        <span class="metadata-insight__eyebrow">
                          {{ 'mobileLogsCatalog.metadataInterpretation.operationalReading' | translate }}
                        </span>
                        <h4>{{ insight.title }}</h4>
                        <p>{{ insight.description }}</p>
                      </div>
                    </div>
                    <span class="metadata-insight__trigger">
                      <mat-icon>bolt</mat-icon>
                      {{ insight.trigger }}
                    </span>
                  </div>

                  @if (insight.items.length) {
                  <div class="metadata-insight__grid">
                    @for (item of insight.items; track item.title) {
                    <article class="metadata-status-card" [attr.data-tone]="item.tone">
                      <span class="metadata-status-card__icon">
                        <mat-icon>{{ item.icon }}</mat-icon>
                      </span>
                      <div class="metadata-status-card__content">
                        <strong>{{ item.title }}</strong>
                        <p>{{ item.description }}</p>
                        @if (item.previous && item.current) {
                        <div class="metadata-status-card__transition">
                          <span>{{ item.previous }}</span>
                          <mat-icon>arrow_forward</mat-icon>
                          <span class="metadata-status-card__current">{{ item.current }}</span>
                        </div>
                        }
                      </div>
                    </article>
                    }
                  </div>
                  }

                  @if (insight.deviceFacts.length) {
                  <div class="metadata-device-strip">
                    @for (fact of insight.deviceFacts; track fact.label) {
                    <div class="metadata-device-fact">
                      <mat-icon>{{ fact.icon }}</mat-icon>
                      <div>
                        <span>{{ fact.label }}</span>
                        <strong>{{ fact.value }}</strong>
                      </div>
                    </div>
                    }
                  </div>
                  }

                  <details class="mobile-log-payload">
                    <summary>
                      <span class="mobile-log-payload__title">
                        <mat-icon>data_object</mat-icon>
                        <span>
                          <strong>{{ 'mobileLogsCatalog.sections.metadata' | translate }}</strong>
                          <small>{{ 'mobileLogsCatalog.metadataInterpretation.rawMetadataHint' | translate }}</small>
                        </span>
                      </span>
                      <mat-icon class="mobile-log-payload__chevron">expand_more</mat-icon>
                    </summary>
                    <pre>{{ log.metadata | json }}</pre>
                  </details>
                </div>
                }
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="mobile-log-empty">
            <mat-icon>smartphone</mat-icon>
            <h4>{{ 'mobileLogsCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'mobileLogsCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="mobile-log-loading"
                         [message]="'mobileLogsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
